import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Badge, Alert } from 'react-bootstrap';

import { capitalizeFirstLetter } from '../../../../util/text.js';

import { getOrderBenefit, getOrderBenefitColor } from '../../OrderHelpers.js';
import { getLoggedUser } from '../../../User/UserActions.js';

import Price from '../../../Currency/components/view/Price.js';
import { formatPrice } from '../../../../util/price.js';

function OrderBenefit({ order, user = null }) {
    const charges = getOrderBenefit(order, 'detail');
    const benefitPercent = getOrderBenefit(order, 'percent');
	const orderTotalTTC = order?.totals?.totalTTC;
    // console.log(charges);
    const renderBenefitKey = (key, isTop = false) => {
        return typeof charges[key] !== 'undefined' && (
            <Row className="m-0 h6 text-black-75 text-lowercase">
                <Col xs="6" className="text-end">
                    {capitalizeFirstLetter(key)}
                </Col>
                <Col xs="6">
					<div className="d-flex justify-content-between">
						{isTop ? <strong><Price amount={charges[key]} /></strong> : <Price amount={charges[key]} />}
						{!isTop && (
							<small className="text-black-50">
								<em>
									{formatPrice((charges[key] * 100) / orderTotalTTC)}%
								</em>
							</small>
						)}
					</div>
                </Col>
            </Row>
        );
    };
    if(user && user.role === 'admin' && order.items?.length) {
        return (
            <Alert variant="light" className="p-2 my-2 border-left border-right rounded">
				<h5 className="px-3">Charges</h5>
                {renderBenefitKey('companyCostHT')}
                {renderBenefitKey('payment')}
                {renderBenefitKey('expedition')}
                {renderBenefitKey('shipping')}
                {renderBenefitKey('commission')}
                {renderBenefitKey('affiliation')}
                {renderBenefitKey('left', true)}
                <Row className="h6 text-black-75">
                    <Col xs="6" className="text-end">
                        Marge
                    </Col>
                    <Col xs="6">
                        <Badge id={`order-benefit-${order._id}`} bg={getOrderBenefitColor(benefitPercent)}>{benefitPercent}%</Badge>
                    </Col>
                </Row>
            </Alert>
        );
    }
    return null;
}

OrderBenefit.propTypes = {
    order: PropTypes.object.isRequired,
    user: PropTypes.object,
};

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
    };
}

export default connect(mapStateToProps)(OrderBenefit);
